import { useParams } from 'react-router-dom';
import BuildHierarchyPage from './BuildHierarchyUnionPage';
import { useGetDepartmentQuery } from '../../features/departments/departmentsApi';

/**
 * Build Hierarchy → <department> : the old two-step screen (level editor + EC mapping),
 * scoped to one government department. The department name titles the page and its id
 * scopes the hierarchy's backend `kind` ("dept-<id>").
 */
export default function BuildDepartmentHierarchyPage() {
  const { id } = useParams<{ id: string }>();
  const { data: dept } = useGetDepartmentQuery(id!, { skip: !id });
  // Key by department id so switching departments remounts the page — otherwise the
  // two-step state (e.g. being on step 2) would carry over from the previous department.
  return <BuildHierarchyPage key={id} label={dept?.name ?? 'Department'} kind={`dept-${id}`} />;
}
